import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { toast } from "@/hooks/use-toast"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Add this utility to help with error reporting
export function checkImport(moduleName: string, fallback: any) {
  try {
    // Just checking if the module imports correctly
    return true;
  } catch (error) {
    console.error(`Failed to import ${moduleName}:`, error);
    return fallback;
  }
}

export const copyToClipboard = (text: string, successMessage: string = "Copied to clipboard") => {
  navigator.clipboard.writeText(text);
  toast({
    title: "Copied",
    description: successMessage,
  });
}

/**
 * Generates a consistent color based on a string identifier
 * @param id A string identifier (like agent ID or title)
 * @returns A color class from the predefined color palette
 */
export const getConsistentColor = (id: string) => {
  const colors = ['bg-blue-500', 'bg-purple-500', 'bg-pink-500', 'bg-indigo-500', 'bg-emerald-500', 'bg-amber-500', 'bg-rose-500', 'bg-cyan-500', 'bg-fuchsia-500', 'bg-lime-500'];
  const hash = id.split('').reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);
  return colors[Math.abs(hash) % colors.length];
};

/**
 * Sanitizes a brand color string to prevent CSS injection
 * Only allows valid hex colors (#abc or #abcdef format)
 * Returns fallback color if invalid
 */
export function sanitizeBrandColor(raw: string | null | undefined, fallback: string = "#060520"): string {
  if (!raw || typeof raw !== 'string') {
    return fallback;
  }
  
  // Test for valid hex color (3 or 6 digits)
  const isValidHex = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(raw);
  return isValidHex ? raw : fallback;
}

